export default {
  companyUrl: 'https://www.lwtears.com',
  pliUrl: 'https://pli.lwtears.com',
  digitalProductSupportUrl: 'https://www.lwtears.com/contact-us/digital-product-support',
  digitalAssetsUrl: 'https://a-z-educator-content.lwtears.com',
};
